document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-goto]');
  if (!button) return;

  var quiz = button.closest('.plant-quiz');
  if (!quiz) return;

  var goto = button.dataset.goto;

  quiz.querySelectorAll('[data-quiz-step]').forEach(function (panel) {
    panel.hidden = panel.dataset.quizStep !== goto;
  });

  if (goto === 'result' && button.dataset.result) {
    var key = button.dataset.result;
    quiz.querySelectorAll('[data-result-for]').forEach(function (card) {
      card.hidden = card.dataset.resultFor !== key;
    });
  }
});
